module.exports = __webpack_public_path__ + "media/img/pages/companies/generali-d5bfe6d95e98be5e9d893f914423ec33.png";